// 0. 主题切换功能
const themeToggle = document.getElementById('themeToggle');
const sunIcon = document.getElementById('sunIcon');
const moonIcon = document.getElementById('moonIcon');
const body = document.body;

// 检查本地存储中的主题设置
const currentTheme = localStorage.getItem('theme') || 'dark';

// 应用保存的主题
if (currentTheme === 'light') {
    body.classList.add('light-mode');
    moonIcon.classList.remove('active');
    sunIcon.classList.add('active');
} else {
    moonIcon.classList.add('active');
    sunIcon.classList.remove('active');
}

// 主题切换事件
themeToggle.addEventListener('click', () => {
    body.classList.toggle('light-mode');
    
    // 切换图标
    sunIcon.classList.toggle('active');
    moonIcon.classList.toggle('active');
    
    // 保存主题设置到本地存储
    const theme = body.classList.contains('light-mode') ? 'light' : 'dark';
    localStorage.setItem('theme', theme);
});

// Tab 切换逻辑
document.addEventListener('DOMContentLoaded', function() {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');

    tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetTab = btn.getAttribute('data-tab');
            
            // 移除所有活跃状态
            tabBtns.forEach(b => b.classList.remove('active'));
            tabContents.forEach(content => content.classList.remove('active'));
            
            // 添加活跃状态
            btn.classList.add('active');
            document.getElementById(targetTab).classList.add('active');
        });
    });
});

// 复制功能
document.addEventListener('DOMContentLoaded', function() {
    const copyableElements = document.querySelectorAll('.copyable');
    
    copyableElements.forEach(element => {
        element.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const textToCopy = this.getAttribute('data-copy') || this.textContent;
            
            try {
                await navigator.clipboard.writeText(textToCopy);
                
                // 添加成功动画
                this.classList.add('copy-success');
                
                // 临时更改文本提示
                const originalTitle = this.getAttribute('title');
                this.setAttribute('title', '已复制！');
                
                // 恢复状态
                setTimeout(() => {
                    this.classList.remove('copy-success');
                    this.setAttribute('title', originalTitle);
                }, 600);
                
            } catch (err) {
                // 降级方案：使用传统方法
                const textArea = document.createElement('textarea');
                textArea.value = textToCopy;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                // 添加成功动画
                this.classList.add('copy-success');
                const originalTitle = this.getAttribute('title');
                this.setAttribute('title', '已复制！');
                
                setTimeout(() => {
                    this.classList.remove('copy-success');
                    this.setAttribute('title', originalTitle);
                }, 600);
            }
        });
    });
});

// 幻灯片功能
let currentSlideIndex = 0;
const slides = document.querySelectorAll('.slide');
const indicators = document.querySelectorAll('.indicator');
let slideInterval;

// 显示指定幻灯片
function showSlide(index) {
    // 移除所有活跃状态
    slides.forEach(slide => slide.classList.remove('active'));
    indicators.forEach(indicator => indicator.classList.remove('active'));
    
    // 添加活跃状态
    if (slides[index]) {
        slides[index].classList.add('active');
    }
    if (indicators[index]) {
        indicators[index].classList.add('active');
    }
    
    currentSlideIndex = index;
}

// 切换到下一张/上一张
function changeSlide(direction) {
    let newIndex = currentSlideIndex + direction;
    
    if (newIndex >= slides.length) {
        newIndex = 0;
    } else if (newIndex < 0) {
        newIndex = slides.length - 1;
    }
    
    showSlide(newIndex);
}

// 跳转到指定幻灯片
function currentSlide(index) {
    showSlide(index - 1); // 转换为0基索引
}

// 自动播放
function startSlideshow() {
    slideInterval = setInterval(() => {
        changeSlide(1);
    }, 10000); // 每10秒切换一次
}

// 停止自动播放
function stopSlideshow() {
    clearInterval(slideInterval);
}

// 初始化幻灯片
document.addEventListener('DOMContentLoaded', function() {
    if (slides.length > 0) {
        showSlide(0);
        startSlideshow();
        
        // 鼠标悬停时停止自动播放
        const slideshowContainer = document.querySelector('.slideshow-container');
        if (slideshowContainer) {
            slideshowContainer.addEventListener('mouseenter', stopSlideshow);
            slideshowContainer.addEventListener('mouseleave', startSlideshow);
        }
    }
});

// 3. 聚光灯效果逻辑 (Spotlight Effect)
const cards = document.querySelectorAll('.spotlight-card');

document.addEventListener('mousemove', (e) => {
    cards.forEach(card => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
    });
});

// 2. 滚动入场动画 (Scroll Reveal)
const revealElements = document.querySelectorAll('.reveal');

const revealOnScroll = () => {
    const windowHeight = window.innerHeight;
    const elementVisible = 100;

    revealElements.forEach((reveal) => {
        const elementTop = reveal.getBoundingClientRect().top;
        if (elementTop < windowHeight - elementVisible) {
            reveal.classList.add('active');
        }
    });
};

window.addEventListener('scroll', revealOnScroll);
// 初始化检查一次
revealOnScroll();

// 3. 导航栏磨砂效果增强
window.addEventListener('scroll', () => {
    const nav = document.getElementById('navbar');
    if (window.scrollY > 50) {
        nav.classList.add('bg-black/80');
        nav.classList.remove('bg-black/50');
    } else {
        nav.classList.add('bg-black/50');
        nav.classList.remove('bg-black/80');
    }
});

// ===== 随机背景图片功能 =====
document.addEventListener('DOMContentLoaded', function() {
    // 背景图片数组
    const backgroundImages = [
        '../img/bg.jpg',
        '../img/bg2.jpg',
        '../img/bg3.jpg',
        '../img/bg4.jpg'
    ];
    
    // 获取上次使用的图片索引
    const lastUsedIndex = localStorage.getItem('lastBackgroundIndex');
    let randomIndex;
    
    // 确保选择的图片与上次不同
    do {
        randomIndex = Math.floor(Math.random() * backgroundImages.length);
    } while (randomIndex === parseInt(lastUsedIndex));
    
    // 保存当前使用的图片索引
    localStorage.setItem('lastBackgroundIndex', randomIndex.toString());
    
    const selectedBackground = backgroundImages[randomIndex];
    
    // 创建样式规则并应用到 Hero 区域
    const style = document.createElement('style');
    style.textContent = `
        .hero-section::before {
            background-image: url('${selectedBackground}') !important;
        }
    `;
    document.head.appendChild(style);
    
    // 输出选择的背景图片信息（在保护功能启用前）
    console.log(`%c🎨 随机背景图片已加载`, 'color: #4ade80; font-size: 14px; font-weight: bold;');
    console.log(`%c当前背景: ${selectedBackground}`, 'color: #60a5fa; font-size: 12px;');
    console.log(`%c背景索引: ${randomIndex} (上次: ${lastUsedIndex || '无'})`, 'color: #f59e0b; font-size: 12px;');
});

// ===== 网站保护功能 =====
// 页面加载完成后设置保护
document.addEventListener('DOMContentLoaded', function() {
    // 设置所有图片不可拖拽
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        img.draggable = false;
    });
    
    // 设置所有链接不可拖拽
    const links = document.querySelectorAll('a');
    links.forEach(link => {
        link.draggable = false;
    });
});

// 禁止右键菜单
document.addEventListener('contextmenu', function(e) {
    e.preventDefault();
    return false;
});

// 禁止选择文本
document.addEventListener('selectstart', function(e) {
    e.preventDefault();
    return false;
});

// 禁止拖拽
document.addEventListener('dragstart', function(e) {
    e.preventDefault();
    return false;
});

// 禁止常用快捷键
document.addEventListener('keydown', function(e) {
    // 禁止 F12 (开发者工具)
    if (e.key === 'F12') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+Shift+I (开发者工具)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+Shift+J (控制台)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+U (查看源代码)
    if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+S (保存页面)
    if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+A (全选)
    if (e.ctrlKey && e.key === 'a') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+C (复制)
    if (e.ctrlKey && e.key === 'c') {
        e.preventDefault();
        return false;
    }
    
    // 禁止 Ctrl+V (粘贴)
    if (e.ctrlKey && e.key === 'v') {
        e.preventDefault();
        return false;
    }
    
});
